export default {
  GET_PRICES: 'GET_PRICES',
  SET_PRICES: 'SET_PRICES',
  GET_DOMAINS: 'GET_DOMAINS',
  SET_DOMAINS: 'SET_DOMAINS',
  GET_TLD_COLLECTION: 'GET_TLD_COLLECTION',
  SET_TLD_COLLECTION: 'SET_TLD_COLLECTION',
  SET_INPUT_VALUE: 'SET_INPUT_VALUE',
  SET_AUTOCOMPLETE_DATA: 'SET_AUTOCOMPLETE_DATA',
  VALIDATE_VALUE: 'VALIDATE_VALUE',
};
